import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, EmpenhoStorage, TransparenciaStorage,} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TransparenciaStorageService extends BaseResourceService<TransparenciaStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`transparencia-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, empenho: number, descricao?: string, foto?: boolean, referencia?: string): Observable<EmpenhoStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }
    if (foto) {
      formData.append('foto', 'S');
    }
    if (referencia)
      formData.append('referencia', referencia)

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<EmpenhoStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${empenho}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
